const B_1 = [
    {
        title: '发布邀请书',
        path: '/bidding/projectflow/fabiao/fbyqs/list'
    }
]
export default {
    path: 'fbyqs',
    component: () => import(/*webpackChunkName: 'bidding-fa-fbyqs'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/fa/fbyqs/list'),
            meta: {
                title: '发布邀请书',
                bread: B_1
            },
        },
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/fa/fbyqs/detail'),
            meta: {
                title: '邀请书详情',
                bread: B_1
            },
        },
        {
            path:"form",
            component: () => import('@views/bidding/views/project-flow/fa/fbyqs/form'),
            meta: {
                title: '添加邀请书',
                bread: B_1
            },
        },
        
    ]
}